import { render } from "./PaymentsPage.vue?vue&type=template&id=37b6bd8a&scoped=true"
import script from "./PaymentsPage.vue?vue&type=script&lang=js"
export * from "./PaymentsPage.vue?vue&type=script&lang=js"

import "./PaymentsPage.vue?vue&type=style&index=0&id=37b6bd8a&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/fep.theismailiusa.org/srv/ibsreg-test.theismailiusa.org/github-httpdocs/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37b6bd8a"]])

export default __exports__